module.exports = __webpack_public_path__ + "img/baizongzi.0c1afe95.jpg";